import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-509933b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Select Plan", -1))
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "feature-text" }
const _hoisted_12 = {
  key: 1,
  class: "mt-2 text-muted d-block feature-text"
}
const _hoisted_13 = {
  key: 2,
  class: "d-flex gap-3 mt-4 flex-wrap w-75"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center px-5" }, "No plans", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$modals.PLANS_MODAL,
    ref: "plansModalRef",
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    backdrop: "static",
    keyboard: "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-icon-primary",
            id: `${_ctx.$modals.PLANS_MODAL}_close`,
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            (_ctx.plans.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.plans, (plan, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: _normalizeClass(["feature-card mb-6 p-4 ribbon rounded", { selected: _ctx.selected?.id === plan?.id }]),
                    onClick: ($event: any) => (_ctx.selectPlan(plan))
                  }, [
                    (plan.is_custom)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "svg-icon svg-icon-1 svg-icon-danger feature-delete",
                          onClick: _withModifiers(($event: any) => (_ctx.removePlan(plan)), ["stop"])
                        }, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen042.svg" })
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["ribbon-label rounded", [
                    _ctx.selected?.id !== plan?.id
                      ? 'bg-primary'
                      : 'bg-light-primary text-primary',
                  ]])
                    }, _toDisplayString(_ctx.$filters.formatCurrency(
                      plan.is_custom
                        ? plan.currency_prices_by_features?.usd ||
                            plan.price_by_features
                        : _ctx.getPlanPriceByCurrency(plan, "usd"),
                      "usd"
                    )), 3),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(plan?.name), 1),
                    (plan?.detail)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(plan?.detail), 1))
                      : _createCommentVNode("", true),
                    (plan.features.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.features, (feature) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge badge-light-primary",
                              key: feature.id
                            }, _toDisplayString(feature.name), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_9))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success w-100 mt-4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: !_ctx.selected?.id
          }, " Proceed ", 8, _hoisted_17)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}